import http from './http';

// The provider key lives on the server, these endpoints require a signed in user.
const API_SPELL_CHECK = '/api/app/ai/spellcheck';
const API_IMPROVE = '/api/app/ai/improve';

const FAILED_MESSAGE = 'Failed to get AI suggestions. Please try again.';

async function post(url, data) {
    const res = await http.request('post', url, data);

    if (res?.Type === 200 && res.Data) return res.Data;

    // http.request reports server side errors itself, this only covers a dead connection.
    if (!res) window.$message.error(FAILED_MESSAGE);

    return null;
}

export default function () {

    function spellCheck(text) {
        return post(API_SPELL_CHECK, { text });
    }

    function improve(text, isHtml = false) {
        return post(API_IMPROVE, { text, isHtml });
    }

    return { spellCheck, improve };
}
